const uiStyles = {
  page: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
    padding: "16px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "transparent",
    minHeight: "100vh",
    boxSizing: "border-box"
  },

  card: {
    background: "rgba(255,255,255,0.84)",
    padding: "18px",
    borderRadius: "20px",
    boxShadow: "0 18px 45px rgba(15,23,42,0.08)",
    border: "1px solid rgba(255,255,255,0.7)",
    backdropFilter: "blur(10px)",
    marginTop: "12px"
  },

  primaryBtn: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "14px",
    border: "none",
    background: "linear-gradient(135deg, #ff7a59, #f25f4c)",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 12px 24px rgba(242,95,76,0.22)",
    transition: "all 0.2s ease"
  },

  secondaryBtn: {
    padding: "10px 14px",
    borderRadius: "14px",
    border: "1px solid #fed7cc",
    background: "rgba(255,255,255,0.86)",
    color: "#8a3c2f",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    transition: "all 0.2s ease"
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "12px",
    border: "1px solid #e7d8d3",
    outline: "none",
    fontSize: "14px",
    marginBottom: "10px",
    color: "#0f172a",
    background: "rgba(255,255,255,0.92)"
  },

  chipBtn: {
    padding: "8px 14px",
    borderRadius: "999px",
    border: "1px solid #f0d9d1",
    background: "rgba(255,255,255,0.92)",
    cursor: "pointer",
    fontSize: "13px",
    transition: "all 0.2s ease"
  },

  chipRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px"
  },

  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 20px",
    background: "rgba(255,250,247,0.9)",
    backdropFilter: "blur(14px)",
    borderBottom: "1px solid rgba(234,179,160,0.28)",
    position: "sticky",
    top: 0,
    zIndex: 100
  },

  logo: {
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: 0.3
  },

  tabs: {
    display: "flex",
    gap: 24
  },

  tab: {
    position: "relative",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    padding: "6px 2px",
    transition: "color 0.2s ease"
  },

  underline: {
    position: "absolute",
    left: 0,
    bottom: -4,
    height: 2,
    width: "100%",
    background: "#f25f4c",
    transformOrigin: "left",
    transition: "transform 0.25s ease",
    borderRadius: 2
  },

  logoText: {
    fontWeight: "700",
    fontSize: "16px"
  }
};

export default uiStyles;
